"use strict";
/**
 * @file Created on 08.06.2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var NSimDummyProduct_1 = require("../model/NSimDummyProduct");

var NSimDummyProductConverter_1 = require("./NSimDummyProductConverter");
/**
 * @author Tomas Leity
 */


var NSimDummyProductConverterImpl =
/*#__PURE__*/
function (_NSimDummyProductConv) {
  _inherits(NSimDummyProductConverterImpl, _NSimDummyProductConv);

  function NSimDummyProductConverterImpl() {
    _classCallCheck(this, NSimDummyProductConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(NSimDummyProductConverterImpl).apply(this, arguments));
  }

  _createClass(NSimDummyProductConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new NSimDummyProduct_1.NSimDummyProduct(NSimDummyProduct_1.NSimDummyProduct.schema.productId.valueOf(conversions.toClassReferenceId(source.productId)), NSimDummyProduct_1.NSimDummyProduct.schema.productName.valueOf(source.productName), NSimDummyProduct_1.NSimDummyProduct.schema.productExternalId.valueOf(source.productExternalId), NSimDummyProduct_1.NSimDummyProduct.schema.promoPrice.valueOf(conversions.toBigNumber(source.promoPrice)), NSimDummyProduct_1.NSimDummyProduct.schema.promoVolume.valueOf(conversions.toBigNumber(source.promoVolume)), NSimDummyProduct_1.NSimDummyProduct.schema.promoPurchasePrice.valueOf(conversions.toBigNumber(source.promoPurchasePrice)));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, {
        productId: conversions.toDocumentReferenceId(source.productId),
        productName: source.productName,
        productExternalId: source.productExternalId,
        promoPrice: conversions.fromBigNumber(source.promoPrice),
        promoVolume: conversions.fromBigNumber(source.promoVolume),
        promoPurchasePrice: conversions.fromBigNumber(source.promoPurchasePrice)
      });
      return result;
    }
  }]);

  return NSimDummyProductConverterImpl;
}(NSimDummyProductConverter_1.NSimDummyProductConverter);

exports.NSimDummyProductConverterImpl = NSimDummyProductConverterImpl;
/**
 * IOC Container qualifier
 */

NSimDummyProductConverterImpl.QUALIFIER = {
  documentType: NSimDummyProduct_1.NSimDummyProduct.name
};